enum InviteUserConstants {
  CLOSE_INVITE_USER_MODAL = '@InviteUser/CLOSE_INVITE_USER_MODAL',
  CLOSE_INVITE_USER_MODAL_AND_RELOAD_USER_LIST = '@InviteUser/CLOSE_INVITE_USER_MODAL_AND_RELOAD_USER_LIST',
  OPEN_INVITE_USER_MODAL = '@InviteUser/OPEN_INVITE_USER_MODAL',
  SEND_USER_INVITE = '@InviteUser/SEND_USER_INVITE',
  SEND_USER_INVITE_REQUEST = '@InviteUser/SEND_USER_INVITE_REQUEST',
  SEND_USER_INVITE_REQUEST_SUCCESS = '@InviteUser/SEND_USER_INVITE_REQUEST_SUCCESS',
  SEND_USER_INVITE_REQUEST_ERROR = '@InviteUser/SEND_USER_INVITE_REQUEST_ERROR',
}

export default InviteUserConstants;
